module.exports = __webpack_public_path__ + "static/media/venue_jiu04.0aba2c8a.jpg";